import React, { useEffect, useState } from 'react';
import {useStyles} from "./styles/AddGroupStyle";
import {
    Box,
    Button,
    Typography,
    TextField,
    FormControl, Select, MenuItem, FormControlLabel, RadioGroup, Radio
} from "@material-ui/core";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ReactComponent as ArrowDownIcon } from '../../../common/images/ArrowDownIcon.svg';
import { ReactComponent as BeforeBtn } from '../../../common/images/BeforeBtn.svg';
import { ReactComponent as CalendarIcon } from '../../../common/images/CalendarIcon.svg';
import {COMMON_UTIL} from "../../../common/util/common.util";
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";
import dayjs from "dayjs";
import {DATE_UTIL} from "../../../common/util/date/date.util";
import GroupDialog from "./GroupDialog";
import NoImage from '../../../common/images/NoImage.jpg'
import {useHistory} from "react-router-dom";
import {URL_TYPE} from "../../../routes/Routes";
import {USER_TYPE} from "../../../stores/UserStore";
import NoticeUploadDialog from './NoticeUploadDialog';
import NoticeViewer from "./NoticeViewer"; // 새로운 컴포넌트 import

function ModifyGroup(props) {
    const classes = useStyles();
    const {intl} = props;
    const history = useHistory();
    const {groupStore, userStore, authStore} = props;
    const userType = authStore.getUserType();

    const [isNoticeDialogOpen, setIsNoticeDialogOpen] = useState(false);
    const [isTooltipVisible, setTooltipVisible] = useState(false);

    const handleEnterLogo = (e) => {
        setTooltipVisible(true);
    }
    const handleLeaveLogo = () => {
        setTooltipVisible(false);
    };

    useEffect(() => {
        groupStore.getGroup(props.match.params.groupId, () => {
            userStore.getLocaleAdminUserIdList(groupStore.modifyGroup.localeCode);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangeLocaleCode = (e) => {
        const localeCode = e.target.value;
        let modifyGroup = Object.assign({}, groupStore.modifyGroup);
        modifyGroup.localeCode = localeCode;
        modifyGroup.localeAdminUserId = ' ';
        groupStore.setModifyGroup(modifyGroup);

        userStore.getLocaleAdminUserIdList(localeCode);
    }

    const handleChangeLocaleAdminUserId = (e) => {
        let modifyGroup = Object.assign({}, groupStore.modifyGroup);
        modifyGroup.localeAdminUserId = e.target.value;
        groupStore.setModifyGroup(modifyGroup);
    }

    const handleChangeLocaleGroupType = (e) => {
        let modifyGroup = Object.assign({}, groupStore.modifyGroup);
        modifyGroup.groupType = e.target.value;
        groupStore.setModifyGroup(modifyGroup);
    }

    const handleChangeLocaleGroupName = (e) => {
        let modifyGroup = Object.assign({}, groupStore.modifyGroup);
        modifyGroup.name = e.target.value;
        groupStore.setModifyGroup(modifyGroup);
    }

    const handleChangeEnable = (e) => {
        let modifyGroup = Object.assign({}, groupStore.modifyGroup);
        modifyGroup.enable = e.target.value;
        groupStore.setModifyGroup(modifyGroup);
    }

    const handleChangeUnlimitedUse = (e) => {
        let modifyGroup = Object.assign({}, groupStore.modifyGroup);
        modifyGroup.unlimitedUse = e.target.value;
        groupStore.setModifyGroup(modifyGroup);
    }

    const handleChangeExpiredDate = (date) => {
        const expiredDate = dayjs(date).format(DATE_UTIL.FORMAT.DATE_FORMAT);
        let modifyGroup = Object.assign({}, groupStore.modifyGroup);
        modifyGroup.expiredDate = expiredDate;
        groupStore.setModifyGroup(modifyGroup);
    }

    const handleChangeTimeZone = (e) => {
        let modifyGroup = Object.assign({}, groupStore.modifyGroup);
        modifyGroup.timeZone = e.target.value;
        groupStore.setModifyGroup(modifyGroup);
    }

    const handleChangeMaxUserCount = (e) => {
        let modifyGroup = Object.assign({}, groupStore.modifyGroup);
        modifyGroup.maxUserCount = Number(e.target.value) >= 0 ? Number(e.target.value) : 0;
        groupStore.setModifyGroup(modifyGroup);
    }


    const handleChangeAiPronunciationCount = (e) => {
        let modifyGroup = Object.assign({}, groupStore.modifyGroup);
        modifyGroup.aiPronunciationCount = Number(e.target.value) >= 0 ? Number(e.target.value) : 0;
        groupStore.setModifyGroup(modifyGroup);
    }

    const handleChangeAiTranslationCount = (e) => {
        let modifyGroup = Object.assign({}, groupStore.modifyGroup);
        modifyGroup.aiTranslationCount = Number(e.target.value) >= 0 ? Number(e.target.value) : 0;
        groupStore.setModifyGroup(modifyGroup);
    }

    const handleChangeAiChatTime = (e) => {
        let modifyGroup = Object.assign({}, groupStore.modifyGroup);
        modifyGroup.aiChatTime = Number(e.target.value) >= 0 ? Number(e.target.value) : 0;
        groupStore.setModifyGroup(modifyGroup);
    }

    const handleClickDialogOpen = (type) => {
        groupStore.setDialogOpen(true, type);
    }

    const handleClickRemoveLogo = (e) => {
        let modifyGroup = Object.assign({}, groupStore.modifyGroup);
        modifyGroup.logo = ''
        groupStore.setModifyGroup(modifyGroup);
    }

    const openFileExplorer = () => {
        const input = document.getElementById('logoUpload');
        input.click();
    }

    const uploadLogo = async (e) => {
        const file = e.target.files[0];
        if (file) {
            try {
                const fileType = file.type.split('/')[1];
                const base64String = await convertFileToBase64(file);

                let modifyGroup = Object.assign({}, groupStore.modifyGroup);
                modifyGroup.logo = `data:image/${fileType};base64,` + base64String;
                groupStore.setModifyGroup(modifyGroup);
            } catch (error) {
                console.error('Error converting logo file to base64:', error);
            }
        }
    }

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                resolve(reader.result.split(',')[1]);
            };

            reader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const handleClickModifyGroup = () => {
        groupStore.updateGroup(groupStore.groupDetail.id, () => groupStore.getGroup(groupStore.groupDetail.id));
    }

    const canModify = () => {
        if (!groupStore.isChangeGroup()) {
            return false;
        }
        const modifyGroup = groupStore.modifyGroup;
        if (modifyGroup.localeAdminUserId === ' ') {
            return false;
        }
        if (modifyGroup.name === '') {
            return false;
        }
        if (modifyGroup.unlimitedUse === 'false' && modifyGroup.expiredDate === '') {
            return false;
        }

        return modifyGroup.maxUserCount > 0;
    }

    const getLogoTooltip = () => {
        const logoEl = document.getElementById('logoImage');
        const rect = logoEl.getBoundingClientRect();

        const top = rect.top - (rect.height * 3);
        const left = rect.left + rect.width;

        return (
            <div className={classes.tooltip} style={{top: top, left: left}}>
                <img
                    className="tooltip-image"
                    style={{height: rect.height * 3}}
                    src={groupStore.modifyGroup.logo}
                    alt="Logo"
                />
            </div>
        )
    }

    const openNoticeDialog = () => {
        setIsNoticeDialogOpen(true);
    }

    const handleNoticeUpload = async (file, url) => {
        try {
            const fileType = file.type.split('/')[1];
            const base64String = await convertFileToBase64(file);

            const newNotice = {
                id: Date.now(),
                notice: `data:image/${fileType};base64,` + base64String,
                url: url
            };

            let modifyGroup = Object.assign({}, groupStore.modifyGroup);
            if (!modifyGroup.notices) {
                modifyGroup.notices = [];
            }
            modifyGroup.notices.push(newNotice);
            groupStore.setModifyGroup(modifyGroup);

            setIsNoticeDialogOpen(false);
        } catch (error) {
            console.error('Error converting notice file to base64:', error);
        }
    }


    const handleNoticeDelete = (noticeId) => {
        let modifyGroup = Object.assign({}, groupStore.modifyGroup);
        console.log("modifyGroup.notices:", modifyGroup.notices);

        modifyGroup.notices = modifyGroup.notices.filter(notice => notice.id !== noticeId);
        groupStore.setModifyGroup(modifyGroup);
    }

    return (
        <Box className={classes.root}>
            {(Object.keys(groupStore.modifyGroup).length !== 0) &&
                <>
                    <Box display={"flex"} justifyContent={"space-between"}>

                    </Box>

                    <Box className={classes.contentBox}>
                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} className={classes.groupInfoBox}>
                            <Typography className={classes.groupInfo}>{intl.formatMessage({id: "group_info_and_authority"})}</Typography>
                        </Box>
                        <Box className={classes.bgBox}>
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} className={classes.searchBox}>
                                {authStore.getUserType() === USER_TYPE.Admin &&
                                    <>
                                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: "Locale"})}<span>*</span></Typography>
                                            <FormControl className={classes.formControl}>
                                                <Select
                                                    value={groupStore.modifyGroup.localeCode}
                                                    onChange={handleChangeLocaleCode}
                                                    IconComponent={(props) => (
                                                        <Box>
                                                            <ArrowDownIcon  {...props} />
                                                        </Box>
                                                    )}
                                                    MenuProps={{
                                                        anchorOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "right"
                                                        },
                                                        transformOrigin:{
                                                            vertical: 'top',
                                                            horizontal: 'right',
                                                        },
                                                        getContentAnchorEl: null,
                                                        className:classes.selectPopover
                                                    }}
                                                >
                                                    {COMMON_UTIL.getLocaleList().map((locale, index) => (
                                                        <MenuItem key={index} value={locale}>{intl.formatMessage({id: locale})}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{marginLeft: 50}}>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: "LocaleAdmin"})}<span>*</span></Typography>
                                            <FormControl className={classes.formControl}>
                                                <Select
                                                    value={userStore.localeAdminUserIdList.length > 0 ? groupStore.modifyGroup.localeAdminUserId : ' '}
                                                    onChange={handleChangeLocaleAdminUserId}
                                                    IconComponent={(props) => (
                                                        <Box>
                                                            <ArrowDownIcon  {...props} />
                                                        </Box>
                                                    )}
                                                    MenuProps={{
                                                        anchorOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "right"
                                                        },
                                                        transformOrigin:{
                                                            vertical: 'top',
                                                            horizontal: 'right',
                                                        },
                                                        getContentAnchorEl: null,
                                                        className:classes.selectPopover
                                                    }}
                                                >
                                                    {(userStore.localeAdminUserIdList.length === 0 || groupStore.modifyGroup.localeAdminUserId === ' ') &&
                                                        <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_admin"})}</MenuItem>
                                                    }
                                                    {userStore.localeAdminUserIdList.length > 0 &&
                                                        userStore.localeAdminUserIdList.map((userId, index) => (
                                                            <MenuItem key={index} value={userId}>{userId}</MenuItem>
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </>
                                }
                                <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={authStore.getUserType() === USER_TYPE.Admin ? {marginLeft: 50} : null}>
                                    {userType === USER_TYPE.GroupAdmin ?
                                        <>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: "group_type"})}</Typography>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: groupStore.modifyGroup.groupType})}</Typography>
                                        </>
                                        :
                                        <>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: "group_type"})}<span>*</span></Typography>
                                            <FormControl className={classes.formControl}>
                                                <Select
                                                    value={groupStore.modifyGroup.groupType}
                                                    onChange={handleChangeLocaleGroupType}
                                                    IconComponent={(props) => (
                                                        <Box>
                                                            <ArrowDownIcon  {...props} />
                                                        </Box>
                                                    )}
                                                    MenuProps={{
                                                        anchorOrigin: {
                                                            vertical: "bottom",
                                                            horizontal: "right"
                                                        },
                                                        transformOrigin:{
                                                            vertical: 'top',
                                                            horizontal: 'right',
                                                        },
                                                        getContentAnchorEl: null,
                                                        className:classes.selectPopover
                                                    }}
                                                >
                                                    {COMMON_UTIL.getGroupTypeList().map((type, index) => (
                                                        <MenuItem key={index} value={type}>{intl.formatMessage({id: type})}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </>
                                    }

                                </Box>
                            </Box>

                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{borderTop: '1px solid #c0c0c0', marginTop: 20, paddingTop: '20px !important'}}>
                                {userType === USER_TYPE.GroupAdmin ?
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Box>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: "locale_timezone"})}</Typography>
                                            <Typography className={classes.noticeText} style={{color: 'black'}}>(UTC± {intl.formatMessage({id: "hour"})})</Typography>
                                        </Box>
                                        <Box className={classes.textQuizBox} style={{width: 240}}>
                                            <Typography className={classes.selectText}>{groupStore.modifyGroup.timeZone}</Typography>
                                        </Box>
                                    </Box>
                                    :
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Box>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: "locale_timezone"})}<span>*</span></Typography>
                                            <Typography className={classes.noticeText} style={{color: 'black'}}>(UTC± {intl.formatMessage({id: "hour"})})</Typography>
                                        </Box>
                                        <Box className={classes.textQuizBox} >
                                            <TextField id="outlined-basic" variant="outlined" type="number" value={groupStore.modifyGroup.timeZone} onChange={handleChangeTimeZone}/>
                                        </Box>
                                    </Box>

                                }
                                {userType === USER_TYPE.GroupAdmin ?
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{marginLeft: 50}}>
                                        <Typography className={classes.selectText}>{intl.formatMessage({id: "group_name"})}</Typography>
                                        <Box className={classes.textQuizBox} style={{width: 240}}>
                                            <Typography className={classes.selectText}>{groupStore.modifyGroup.name}</Typography>
                                        </Box>
                                    </Box>
                                    :
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{marginLeft: 50}}>
                                        <Typography className={classes.selectText}>{intl.formatMessage({id: "group_name"})}<span>*</span></Typography>
                                        <Box className={classes.textQuizBox} >
                                            <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "group_name"})} value={groupStore.modifyGroup.name} onChange={handleChangeLocaleGroupName} />
                                        </Box>
                                    </Box>
                                }
                            </Box>

                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{borderTop: '1px solid #c0c0c0', marginTop: 20, paddingTop: '20px !important'}}>
                                {userType === USER_TYPE.GroupAdmin ?
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Box>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: "pronunciation_test"})}</Typography>
                                            <Typography className={classes.noticeText} style={{color: 'black'}}>({intl.formatMessage({id: "number_of_uses_per_day"})})</Typography>
                                        </Box>
                                        <Box className={classes.textQuizBox} style={{width: 240}}>
                                            <Typography className={classes.selectText}>{groupStore.modifyGroup.aiPronunciationCount}</Typography>
                                        </Box>
                                    </Box>
                                    :
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Box>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: "pronunciation_test"})}<span>*</span></Typography>
                                            <Typography className={classes.noticeText} style={{color: 'black'}}>({intl.formatMessage({id: "number_of_uses_per_day"})})</Typography>
                                        </Box>
                                        <Box className={classes.textQuizBox} >
                                            <TextField id="outlined-basic" variant="outlined" type="number" value={groupStore.modifyGroup.aiPronunciationCount} onChange={handleChangeAiPronunciationCount}/>
                                        </Box>
                                    </Box>
                                }

                                {userType === USER_TYPE.GroupAdmin ?
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{marginLeft: 50}}>
                                        <Box>
                                            <Typography className={classes.selectText}>AI {intl.formatMessage({id: "translation"})}</Typography>
                                            <Typography className={classes.noticeText} style={{color: 'black'}}>({intl.formatMessage({id: "number_of_uses_per_day"})})</Typography>
                                        </Box>
                                        <Box className={classes.textQuizBox} style={{width: 240}}>
                                            <Typography className={classes.selectText}>{groupStore.modifyGroup.aiTranslationCount}</Typography>
                                        </Box>
                                    </Box>
                                    :
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{marginLeft: 50}}>
                                        <Box>
                                            <Typography className={classes.selectText}>AI {intl.formatMessage({id: "translation"})}<span>*</span></Typography>
                                            <Typography className={classes.noticeText} style={{color: 'black'}}>({intl.formatMessage({id: "number_of_uses_per_day"})})</Typography>
                                        </Box>
                                        <Box className={classes.textQuizBox} >
                                            <TextField id="outlined-basic" variant="outlined" type="number" value={groupStore.modifyGroup.aiTranslationCount} onChange={handleChangeAiTranslationCount}/>
                                        </Box>
                                    </Box>
                                }

                                {userType === USER_TYPE.GroupAdmin ?
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{marginLeft: 50}}>
                                        <Box>
                                            <Typography className={classes.selectText}>AI {intl.formatMessage({id: "conversation"})}</Typography>
                                            <Typography className={classes.noticeText} style={{color: 'black'}}>({intl.formatMessage({id: "seconds_of_uses_per_day"})})</Typography>
                                        </Box>
                                        <Box className={classes.textQuizBox} style={{width: 240}}>
                                            <Typography className={classes.selectText}>{groupStore.modifyGroup.aiChatTime}</Typography>
                                        </Box>
                                    </Box>
                                    :
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{marginLeft: 50}}>
                                        <Box>
                                            <Typography className={classes.selectText}>AI {intl.formatMessage({id: "conversation"})}<span>*</span></Typography>
                                            <Typography className={classes.noticeText} style={{color: 'black'}}>({intl.formatMessage({id: "seconds_of_uses_per_day"})})</Typography>
                                        </Box>
                                        <Box className={classes.textQuizBox} >
                                            <TextField id="outlined-basic" variant="outlined" type="number" value={groupStore.modifyGroup.aiChatTime} onChange={handleChangeAiChatTime}/>
                                        </Box>
                                    </Box>
                                }
                            </Box>

                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{borderTop: '1px solid #c0c0c0', marginTop: 20, paddingTop: '20px !important'}}>
                                <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} className={classes.threeGrid} sx={{maxWidth: 380}}>
                                    {userType === USER_TYPE.GroupAdmin ?
                                        <>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: "use_status"})}</Typography>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: groupStore.modifyGroup.enable ? 'Enable' : 'Disable'})}</Typography>
                                        </>
                                        :
                                        <>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: "use_status"})}<span>*</span></Typography>
                                            <Box>
                                                <RadioGroup row className={classes.radioGroup} value={groupStore.modifyGroup.enable} onChange={handleChangeEnable}>
                                                    <FormControlLabel value='true' control={<Radio disableRipple />} label={intl.formatMessage({id: "available"})} />
                                                    <FormControlLabel value='false' control={<Radio disableRipple />} label={intl.formatMessage({id: "unavailable"})} />
                                                </RadioGroup>
                                            </Box>
                                        </>
                                    }

                                </Box>
                                <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} className={classes.threeGrid} sx={{maxWidth: 500, marginRight: 20}}>
                                    {userType === USER_TYPE.GroupAdmin ?
                                        <>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: "use_date"})}</Typography>
                                            <Typography className={classes.selectText}>{groupStore.modifyGroup.unlimitedUse === 'true' ? intl.formatMessage({id: 'unlimited'}) : dayjs(groupStore.modifyGroup.expiredDatetime).format(DATE_UTIL.FORMAT.DATE_FORMAT)}</Typography>
                                        </>
                                        :
                                        <>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: "use_date"})}<span>*</span></Typography>
                                            <Box sx={{width: 235}}>
                                                <RadioGroup row className={classes.radioGroup} value={groupStore.modifyGroup.unlimitedUse} onChange={handleChangeUnlimitedUse}>
                                                    <FormControlLabel value='true' control={<Radio disableRipple />} label={intl.formatMessage({id: "unlimited"})} />
                                                    <FormControlLabel value='false' control={<Radio disableRipple />} label={intl.formatMessage({id: "limited"})} />
                                                </RadioGroup>
                                            </Box>
                                            {groupStore.modifyGroup.unlimitedUse === 'false' &&
                                                <>
                                                    <Box>
                                                        <Typography className={classes.dueDayText}>{intl.formatMessage({id: "expire_date"})}</Typography>
                                                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                                            <Box className={classes.datePicker}>
                                                                <DatePicker
                                                                    showIcon
                                                                    icon={
                                                                        <CalendarIcon
                                                                            style={{
                                                                                position: "absolute",
                                                                                top: "50%",
                                                                                transform: "translateY(-50%)",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        />}
                                                                    minDate={new Date()}
                                                                    selected={groupStore.modifyGroup.expiredDate !== '' ? new Date(groupStore.modifyGroup.expiredDate) : new Date()}
                                                                    onSelect={(date) => handleChangeExpiredDate(date)}
                                                                    dateFormat="yyyy-MM-dd"
                                                                    shouldCloseOnSelect={true}
                                                                    toggleCalendarOnIconClick
                                                                />
                                                            </Box>
                                                        </Box>
                                                        <Typography style={{fontSize: '0.6rem'}} className={classes.noticeText}>{intl.formatMessage({id: "msg_info_expire_date"})}</Typography>
                                                    </Box>
                                                </>
                                            }
                                        </>
                                    }
                                </Box>
                                <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} className={classes.threeGrid}>
                                    {userType === USER_TYPE.GroupAdmin ?
                                        <>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: "create_account_count"})}</Typography>
                                            <Typography className={classes.selectText}>{groupStore.modifyGroup.maxUserCount}</Typography>
                                        </>
                                        :
                                        <>
                                            <Typography className={classes.selectText}>{intl.formatMessage({id: "create_account_count"})}<span>*</span></Typography>
                                            <Box className={classes.textQuizBox} >
                                                <TextField id="outlined-basic" variant="outlined" type="number" value={groupStore.modifyGroup.maxUserCount} onChange={handleChangeMaxUserCount}/>
                                            </Box>
                                        </>
                                    }
                                </Box>
                            </Box>
                        </Box>
                        <Box>
                            <Typography className={classes.boxTitle}>{intl.formatMessage({id: "normal_account_settings"})}</Typography>
                            <Box className={classes.bgBox}>
                                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.mainText}>{intl.formatMessage({id: "group_default_email"})}</Typography>
                                        <Typography className={classes.subText}>{intl.formatMessage({id: "group_default_email_description"})}</Typography>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.selectText}>{groupStore.modifyGroup.defaultEmail}</Typography>
                                        <Button className={classes.setButton} onClick={() => handleClickDialogOpen('email')} disableRipple>
                                            <Typography>{intl.formatMessage({id: "input"})}</Typography>
                                        </Button>
                                        <GroupDialog />
                                    </Box>
                                </Box>
                                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} sx={{borderTop: '1px solid #c0c0c0', marginTop: 20, paddingTop: '20px !important'}}>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.mainText}>{intl.formatMessage({id: "group_default_password"})}</Typography>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.selectText}>{groupStore.modifyGroup.defaultPassword}</Typography>
                                        <Button className={classes.setButton} onClick={() => handleClickDialogOpen('password')} disableRipple>
                                            <Typography>{intl.formatMessage({id: "input"})}</Typography>
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>

                        <Box>
                            <Typography className={classes.boxTitle}>{intl.formatMessage({id: "app_settings"})}</Typography>
                            <Box className={classes.bgBox}>
                                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.mainText}>{intl.formatMessage({id: "logo_image"})}</Typography>
                                        <Box className={classes.pic}>
                                            {(groupStore.modifyGroup.logo !== '' && groupStore.modifyGroup.logo !== null) ?
                                                <div className="imageContainer" style={{height: '100%'}}>
                                                    <img
                                                        id='logoImage'
                                                        style={{height: '100%'}}
                                                        src={groupStore.modifyGroup.logo}
                                                        alt="Logo"
                                                        onMouseEnter={handleEnterLogo}
                                                        onMouseLeave={handleLeaveLogo}
                                                    />
                                                    {isTooltipVisible &&
                                                        getLogoTooltip()
                                                    }
                                                </div>
                                                :
                                                <img className={classes.iconBtn} style={{height: '100%'}} src={NoImage} alt='NoImage'/>
                                            }
                                        </Box>
                                    </Box>
                                    <Box>
                                        <Button className={classes.setButton} disableRipple onClick={handleClickRemoveLogo} >
                                            <Typography>{intl.formatMessage({id: "delete"})}</Typography>
                                        </Button>
                                        <Button className={classes.setButton} disableRipple onClick={openFileExplorer} >
                                            <Typography>{intl.formatMessage({id: "register"})}</Typography>
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                            <Box className={classes.bgBox}>
                                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.mainText}>{intl.formatMessage({id: "notice"})}</Typography>
                                        <NoticeViewer
                                            notices={groupStore.modifyGroup.notices || []}
                                            onDelete={handleNoticeDelete}
                                        />
                                    </Box>
                                    <Box>
                                        <Button className={classes.setButton} disableRipple onClick={openNoticeDialog} >
                                            <Typography>{intl.formatMessage({id: "register"})}</Typography>
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} sx={{marginTop: 10}}>
                        <Box>
                            <Button className={classes.preBtn} disableRipple onClick={() => history.push(URL_TYPE.GroupList)}>
                                <BeforeBtn />
                                <Typography>{intl.formatMessage({id: "previous"})}</Typography>
                            </Button>
                        </Box>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                            <Button className={classes.finishButton} style={!canModify() ? {background: '#87888d'} : null} disableRipple onClick={handleClickModifyGroup} disabled={!canModify()}>
                                <Typography>{intl.formatMessage({id: "modify"})}</Typography>
                            </Button>
                        </Box>
                    </Box>
                    <input id={'logoUpload'} style={{ display: 'none' }} accept={".jpg, .jpeg, .png"} onChange={uploadLogo} placeholder={intl.formatMessage({id: "full_file"})} type={'file'}/>
                    <NoticeUploadDialog
                        open={isNoticeDialogOpen}
                        onClose={() => setIsNoticeDialogOpen(false)}
                        onUpload={handleNoticeUpload}
                    />
                </>
            }
        </Box>
    );
}

export default inject('groupStore', 'userStore', 'authStore')(injectIntl(observer(ModifyGroup)));
